var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"tab-wrap",class:{
    'tab-progress': _vm.$slots.bar,
    'tab-sticky-active': _vm.isSticky,
    'tab-sticky-header': _vm.isHeaderShow,
    'tab-sticky-sub': _vm.isSubTab
  }},'div',_vm.$attrs,false),[_c('div',{staticClass:"tab-inner"},[_c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab-scroll"},_vm._l((_vm.tabList),function(item,key){return _c('router-link',_vm._g({key:key,ref:"tab",refInFor:true,class:_vm.index > -1 ? {
            active: _vm.index === key
          } : '',attrs:{"to":{
            name: item.path,
            params: {
              ...item.params,
              locale: _vm.$route.params.locale
            },
            query : {
              ...item.query
            },
            hash: item.hash
          },"active-class":_vm.index === -1 ? 'active' : 'router-link-active'},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])}),1),_vm._t("bar")],2),_vm._t("sub")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }